module.exports = __webpack_public_path__ + "img/reading.720efe38.png";